import React from "react";

interface ExternalLinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  innerRef?: React.Ref<HTMLAnchorElement>;
}

export const ExternalLinkWrapper = ({
  href,
  children,
  innerRef,
  ...rest
}: ExternalLinkButtonProps) => {
  return (
    <a href={href} rel="noreferrer" target="_blank" ref={innerRef} {...rest}>
      {children}
    </a>
  );
};
